import { render, staticRenderFns } from "./AppSalesIcon.vue?vue&type=template&id=3efb7620"
import script from "./AppSalesIcon.vue?vue&type=script&lang=js"
export * from "./AppSalesIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports